__turbopack_context__.v({
  "cardLink": "styles-module-scss-module__uZaYLa__cardLink",
  "chevronIcon": "styles-module-scss-module__uZaYLa__chevronIcon",
  "filterControls": "styles-module-scss-module__uZaYLa__filterControls",
  "introText": "styles-module-scss-module__uZaYLa__introText",
  "mantineInput": "styles-module-scss-module__uZaYLa__mantineInput",
  "regionHeader": "styles-module-scss-module__uZaYLa__regionHeader",
  "regionSection": "styles-module-scss-module__uZaYLa__regionSection",
  "searchInput": "styles-module-scss-module__uZaYLa__searchInput",
  "selectInput": "styles-module-scss-module__uZaYLa__selectInput",
  "selectOption": "styles-module-scss-module__uZaYLa__selectOption",
  "vendorCard": "styles-module-scss-module__uZaYLa__vendorCard",
  "vendorGrid": "styles-module-scss-module__uZaYLa__vendorGrid",
  "vendorList": "styles-module-scss-module__uZaYLa__vendorList",
});
